module.exports = __webpack_public_path__ + "media/images/page/lp-sample_large6-b70dbae8dfb85eec65963ed24de91e21.jpg";